<template>
  <div>
    <div
      class="
        uk-section uk-padding-remove-vertical uk-margin-remove-vertical
        in-equity-breadcrumb in-equity-breadcrumb-green
      "
    >
      <div class="uk-container">
        <div class="uk-grid">
          <div class="uk-width-1-1">
            <ul class="uk-breadcrumb">
              <li>
                <router-link :to="{ name: 'guest.home' }">Home</router-link>
              </li>
              <li>
                <router-link :to="{ name: 'guest.signals' }"
                  >Community</router-link
                >
              </li>
              <li>
                <span
                  >{{ plan.months }} Month{{
                    plan.months == 1 ? "" : "s"
                  }}</span
                >
              </li>
              <li><span>Payment</span></li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div
      class="uk-section uk-padding-remove-vertical uk-margin-remove-vertical"
    >
      <div class="uk-container uk-margin-top uk-padding">
        <h2>Join The Community</h2>
        <hr>
        <div
          class="uk-child-width-1-1 uk-child-width-1-3@m uk-grid"
          data-uk-grid=""
        >
          <div class="uk-first-column uk-background-default uk-margin-right uk-padding">
            <h4>Payment Details</h4>
            <table class="uk-table uk-table-divider">
              <tbody>
                <tr>
                  <td>Package</td>
                  <td>{{ plan.months }} Month{{
                    plan.months == 1 ? "" : "s"
                  }}</td>
                </tr>
                <tr>
                  <td>Amount</td>
                  <td>$ {{ plan.amount }}</td>
                </tr>
                <tr v-if="plan.discount != null">
                  <td>Discount</td>
                  <td>{{ plan.discount }} % Applied</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="uk-background-default uk-padding uk-width-1-2@m">
            <div class="uk-row-first">
              <payment
                type="community"
                :id="$route.params.id"
                @received="paymentReceived"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.fetch()
  },

  data() {
    return {
      plan: {},
    }
  },

  methods: {
    fetch() {
      this.$loader.start('full')
      this.$axios.get(`/api/v1/guest/community/subscribe/${this.$route.params.id}`).then(response => {
        this.plan = response.data.plan
        this.$loader.stop()
      })
    },

    paymentReceived() {
      window.location.href = this.$router.resolve({ name: 'redirect' }).href
    }
  },

  computed: {
    user() {
      return this.$store.getters.getAuthUser
    }
  }
};
</script>
